export default class PostSubscriptionRequestObject {
  public organizationId: string = ''
  public productId: string = ''
  public licenseType: number = 0
  public subscriptionStartDate: string = ''
  public subscriptionEndDate: string = ''
  public serialNumber: string = ''
  public licenseCount: number = 0
  public updatedSerialNumber: string = ''
}
